var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(this.labelText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }